import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import './how.to.less';

const HowTo = () => (
  <div className="o-investors">
    <div className="m-globalContentContainer">
      <div className="m-investors__container --gray --padding">
        <h2 className="m-investors__text__title m-investors-howto__title">
          <Trans i18nKey="web.investors.how.to.title" />
        </h2>
        <div className="m-investors__banner m-investors__centered">
          <div className="m-investors__text --box --border m-investors__badge --point-one">
            <h2 className="m-investors__text__title --no-border">
              <Trans i18nKey="web.investors.how.to.register" />
            </h2>
            <p className="m-investors__text__brand_normal --blue">
              <Trans i18nKey="web.investors.how.to.click" />
            </p>
          </div>
          <div className="m-investors__text --box --border m-investors__badge --point-two">
            <h2 className="m-investors__text__title --no-border">
              <Trans i18nKey="web.investors.how.to.amount.invest" />
            </h2>
            <p className="m-investors__text__brand_normal --blue">
              <Trans i18nKey="web.investors.how.to.open" />
            </p>
          </div>
          <div className="m-investors__text --box --border m-investors__badge --point-three">
            <h2 className="m-investors__text__title --no-border">
              <Trans i18nKey="web.investors.how.to.earn" />
            </h2>
            <p className="m-investors__text__brand_normal --blue">
              <Trans i18nKey="web.investors.how.to.widthraw" />
            </p>
          </div>
        </div>
      </div>
      <div className="m-investors__separator" />
    </div>
  </div>
);

export default HowTo;
